/**
 * Scraper lane state → BaseTag tone.
 *
 * `unknown` is deliberately coloured as a problem: being unable to measure a source is not
 * reassuring, and silence is precisely the dangerous case. `paused` is neutral — that is a decision
 * someone recorded, not a fault.
 */
export function getScraperHealthStateTone(state) {
  switch (state) {
    case 'ok':
      return 'success';
    case 'stale':
      return 'warning';
    case 'failing':
      return 'destructive';
    case 'unknown':
      return 'orange';
    case 'paused':
      return 'neutral';
    default:
      // Fail towards a problem, not towards neutral. A state the front-end does not recognise means
      // the back-end added one: rendering it like `paused` would make it read as a deliberate
      // decision, and therefore invisible. Better a colour that alarms wrongly than a hidden fault.
      return 'orange';
  }
}

/**
 * Source service level → BaseTag tone. Kept next to the lane tones so the two never drift apart:
 * a source reading "Hors service" in red beside three lanes in a different palette would be read as
 * two unrelated verdicts rather than one summary of the others.
 */
export function getScraperHealthServiceTone(level) {
  switch (level) {
    case 'ok':
      return 'success';
    case 'degraded':
      return 'warning';
    case 'down':
      return 'destructive';
    case 'paused':
      return 'neutral';
    default:
      return 'orange'; // unknown, and anything unrecognised — see above
  }
}
